import React, { Fragment, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { translate } from '../../../Services/translation';
import { isEcomAdmin } from '../../Services/Api.service';

export const EcommerceLandingPage = () => { 
    const[ecomAdmin, setecomAdmin] = useState(isEcomAdmin());   

    return(
        <Fragment>
            <div className='ecommerce-landing__header'>{translate("coptikk.adminportal.ecommercelanding.customer.headertext")}</div>
            <div className='ecommerce-landing__link'>
                <NavLink to="/customersearch">{translate("coptikk.adminportal.customer.searchlinktext")}</NavLink>
            </div>
            <div className='ecommerce-landing__link'>
                <NavLink to="/gdprrequest">{translate("coptikk.adminportal.gdprapproval.registernewcustomer")}</NavLink>
            </div>
            <div className='ecommerce-landing__link'>
                <NavLink to="/gdprcontinue" target='_blank'>{translate("coptikk.gdprapproval.continueregister")}</NavLink>
            </div>
            <div  className='ecommerce-landing__link'>
                <NavLink to="/subscriptionlist">{translate("coptikk.adminportal.customer.subscriptionlist")}</NavLink>
            </div>

            <div className='ecommerce-landing__header'>{translate("coptikk.adminportal.ecommercelanding.order.headertext")}</div>
            <div className='ecommerce-landing__link'>
                <NavLink to="/orderlist">{translate("coptikk.adminportal.customer.orderlist")}</NavLink>
            </div>            
            <div className='ecommerce-landing__link'>
                <NavLink to="/ordersearchcompleteddate">{translate("coptikk.adminportal.completedorders.basedoncompleteddate")}</NavLink>
            </div> 
            <div className='ecommerce-landing__link'>
                <NavLink to="/ordersearch">{translate("coptikk.adminportal.completedorders.linkheader")}</NavLink>
            </div>  
            <div className='ecommerce-landing__link'>
                <NavLink to="/subscriptionandonetimeexport">{translate("coptikk.adminportal.completedorders.subscriptionandonetime.header")}</NavLink>
            </div>
            <div className='ecommerce-landing__link'>
                <NavLink to="/aggregateturnovercompleteddate">{translate("coptikk.adminportal.aggregateturnover.basedoncompleteddate")}</NavLink>
            </div>                                
            {ecomAdmin && <div className='ecommerce-landing__link'>
                <NavLink to="/aggregateturnover">{translate("coptikk.adminportal.aggregateturnover")}</NavLink>
            </div>}                        

            <div className='ecommerce-landing__header'>{translate("coptikk.adminportal.ecommercelanding.storesettings.headertext")}</div>
            <div className='ecommerce-landing__link'>
                <NavLink to="/storesettings">{translate('coptikk.adminportal.storesettings')}</NavLink>
            </div>
        </Fragment>
    )
}